var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77143 16.8571V4.51425M9.77143 16.8571L8.55687 15.6425C7.87102 14.9567 6.94123 14.5714 5.97129 14.5714H2.91349C2.40854 14.5714 2 14.1621 2 13.6571V4.05711C2 3.55216 2.40934 3.14282 2.91429 3.14282H6.42802C7.39795 3.14282 8.32816 3.52813 9.01401 4.21397L9.77143 4.97139L10.5288 4.21397C11.2147 3.52813 12.1449 3.14282 13.1148 3.14282H17.0857C17.5907 3.14282 18 3.55216 18 4.05711V13.6571C18 14.1621 17.5907 14.5714 17.0857 14.5714H13.572C12.602 14.5714 11.6718 14.9567 10.986 15.6425L9.77143 16.8571Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook02);
export default __webpack_public_path__ + "static/media/book-02.8aef347574460c9bdd0e6c975faeea80.svg";
export { ForwardRef as ReactComponent };